import React, { useState } from "react";

const UsersStore = (WrappedComponent) => {
    const UsersStoreComponent = (props) => {
        const [userState, setUserState] = useState({
            showDrawer: false,
            formType: "",
            initialValues: null
        });

        const [pagination, setPagination] = useState({
            pageNo: 0,
            limit: 10,
            sortBy: "DESC",
            sortField: "created_at",
            keywords: ""
        });

        const changeUserInitialState = (newState) => {
            setUserState(prevState => ({
                ...prevState,
                ...newState
            }));
        };

        const handlePaginationState = (newPagination) => {
            setPagination(prevState => ({
                ...prevState,
                ...newPagination
            }));
        };

        return (
            <WrappedComponent
                {...props}
                showDrawer={userState.showDrawer}
                formType={userState.formType}
                initialValues={userState.initialValues}
                pagination={pagination}
                changeUserInitialState={changeUserInitialState}
                handlePaginationState={handlePaginationState}
            />
        );
    };

    return UsersStoreComponent;
};

export default UsersStore;